import { Box, Modal, styled } from '@mui/material';

export const StyledBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: 'translate(-50%; -50%)';
  max-width: 400;
  width: 80%;
  background-color: white;
  border: 2px solid #000;
  box-shadow: 24;
  padding: 4;
`;

export const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 60;
`;